
import localStore from 'store';

let cPSWinSt;

export function canPersonalSettings(key: string): boolean {  
  if (!cPSWinSt) { 
    cPSWinSt = localStore.get('settings').personal; 
  };
  if (cPSWinSt && cPSWinSt[key]) {
    const setting = cPSWinSt[key] || {};
    if (setting.hasOwnProperty('value')) {
      return Boolean(setting['value']);
    } else {
      return false;
    }
  }
  return false;
}